import { atom } from 'jotai';

export const tasksOnAtom = atom<boolean>(true);
